import {Component, OnInit} from '@angular/core';
import {UtilsService} from '../../../services/utils.service';
import {Router} from '@angular/router';
import {FaqService} from '../../../services/faq.service';
import {TagService} from '../../../services/tag.service';

@Component({
  selector: 'app-new-faq',
  templateUrl: './new-faq.component.html',
  styleUrls: ['./new-faq.component.scss']
})
export class NewFaqComponent implements OnInit {

  faq = {
    title: '',
    slug: '',
    body: '',
    notes: '',
    priority: 0,
    published: false,
    tags: []
  };
  allTags: any[] = [];
  filteredTags: any[] = [];
  searchQuery: string = '';
  showDropdown: boolean = false;
  faqError: string = '';
  
  constructor(private graphqlService: FaqService,
              private utilsService: UtilsService,
              private tagService: TagService,
              private router: Router) {
  }

  ngOnInit() {
    this.loadTags();
  }

  loadTags() {
    this.tagService.listFaqForAutocomplete().subscribe(result => {
      if (result && result.data && result.data['tags'] && result.data['tags']['edges']) {
        this.allTags = result.data['tags']['edges'].map(edge => edge['node']);
        this.filteredTags = [...this.allTags];
      }
    });
  }

  // Custom tag input methods
  onTagInputFocus() {
    this.showDropdown = true;
    this.filterTags();
  }

  onTagInputBlur() {
    // Delay hiding dropdown to allow for clicks
    setTimeout(() => {
      this.showDropdown = false;
    }, 200);
  }

  onTagSearch(event: any) {
    this.searchQuery = event.target.value;
    this.filterTags();
  }

  filterTags() {
    if (!this.searchQuery) {
      this.filteredTags = this.allTags.filter(tag => 
        !this.faq.tags.some(selectedTag => selectedTag.id === tag.id)
      );
    } else {
      this.filteredTags = this.allTags.filter(tag => 
        tag.name.toLowerCase().includes(this.searchQuery.toLowerCase()) &&
        !this.faq.tags.some(selectedTag => selectedTag.id === tag.id)
      );
    }
  }

  addTag(tag: any) {
    if (this.faq.tags.length < 12 && !this.faq.tags.some(t => t.id === tag.id)) {
      this.faq.tags.push(tag);
      this.searchQuery = '';
      this.filterTags();
    }
  }

  removeTag(tagToRemove: any) {
    this.faq.tags = this.faq.tags.filter(tag => tag.id !== tagToRemove.id);
    this.filterTags();
  }

  addFaq() {
    const requiredSuccess = this.utilsService.validateRequiredFields(this.faq.title);
    if (requiredSuccess) {
      this.graphqlService.create(this.faq).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('Faq Created !!', '');
          this.router.navigate(['/faqs']);
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to create faq.', '');
        console.log('there was an error sending the query', error);
      });
    }
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/faqs/new-faq/new-faq.component.ts